import axios from 'axios';

export const Axios = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_ROUTE || 'https://cocoyoc-backend.herokuapp.com',
});
